var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "form-incident-general-detail" },
    [
      _c("h4", { staticClass: "mb-1 mt-1" }, [
        _vm._v(_vm._s(_vm.$t("incident_form.title_01")))
      ]),
      _c("hr"),
      _c(
        "b-form-group",
        { attrs: { label: "A) " + _vm.$t("incident_form_responsible_email") } },
        [
          _c("div", [
            _vm._v(_vm._s(_vm._.get(_vm.entity, "responsible_email") || "-"))
          ])
        ]
      ),
      _c(
        "b-form-group",
        { attrs: { label: "B) " + _vm.$t("incident_form_group") } },
        [
          _vm.getIncidentGroupNames.length ||
          _vm._.get(_vm.entity, "other_group")
            ? _c(
                "div",
                [
                  _vm._l(_vm.getIncidentGroupNames, function(groupName, index) {
                    return _c("span", { key: index }, [
                      _vm._v(" " + _vm._s(groupName)),
                      index < _vm.getIncidentGroupNames.length - 1 ||
                      _vm._.get(_vm.entity, "other_group")
                        ? _c("span", [_vm._v(", "), _c("br")])
                        : _vm._e()
                    ])
                  }),
                  _vm._.get(_vm.entity, "other_group")
                    ? _c("span", [
                        _vm._v(
                          " Outro: " +
                            _vm._s(_vm._.get(_vm.entity, "other_group")) +
                            " "
                        )
                      ])
                    : _vm._e()
                ],
                2
              )
            : _c("div", [_vm._v("-")])
        ]
      ),
      _c(
        "b-form-group",
        {
          attrs: {
            label: "C) " + _vm.$t("incident_form_authority_identification")
          }
        },
        [
          _c("div", [
            _vm._v(_vm._s(_vm._.get(_vm.entity, "legal_entity.name") || "-"))
          ])
        ]
      ),
      _c(
        "b-form-group",
        {
          attrs: {
            label:
              "D) " +
              _vm.$t("incident_form_operator_identification") +
              " (" +
              _vm.$t("when_applicable") +
              ")"
          }
        },
        [
          _c("div", [
            _vm._v(
              _vm._s(_vm._.get(_vm.entity, "operator_identification") || "-")
            )
          ])
        ]
      ),
      _c(
        "b-form-group",
        {
          attrs: {
            label: "E) " + _vm.$t("incident_form_data_authority_description")
          }
        },
        [
          _c("div", { staticClass: "text-break" }, [
            _vm._v(
              _vm._s(_vm._.get(_vm.entity, "data_authority_description") || "-")
            )
          ])
        ]
      ),
      _c(
        "b-form-group",
        {
          attrs: {
            label:
              "F) " +
              _vm.$t("incident_form_who_reported") +
              _vm.$t("incident_form_name_tel_email")
          }
        },
        [
          _c("div", { staticClass: "text-break" }, [
            _vm._v(_vm._s(_vm._.get(_vm.entity, "who_reported") || "-"))
          ])
        ]
      ),
      _c(
        "b-form-group",
        {
          attrs: {
            label:
              "G) " +
              _vm.$t("incident_form_responsible_unit") +
              _vm.$t("incident_form_name_tel_email")
          }
        },
        [
          _c("div", { staticClass: "text-break" }, [
            _vm._v(_vm._s(_vm._.get(_vm.entity, "responsible_unit") || "-"))
          ])
        ]
      ),
      _c("h4", { staticClass: "mb-1 mt-1" }, [
        _vm._v(_vm._s(_vm.$t("incident_form.title_02")))
      ]),
      _c("hr"),
      _c(
        "b-form-group",
        {
          attrs: {
            label:
              "A) " +
              _vm.$t("incident_form_description_incident") +
              " (" +
              _vm.$t("incident_form_root_cause") +
              ")"
          }
        },
        [
          _c("div", { staticClass: "text-break" }, [
            _vm._v(_vm._s(_vm._.get(_vm.entity, "description") || "-"))
          ])
        ]
      ),
      _c(
        "b-form-group",
        { attrs: { label: "B) " + _vm.$t("incident_form_affected") } },
        [
          _vm.getAcidPropertyNames.length
            ? _c(
                "div",
                _vm._l(_vm.getAcidPropertyNames, function(propertyName, index) {
                  return _c("span", { key: index }, [
                    _vm._v(" " + _vm._s(propertyName)),
                    index < _vm.getAcidPropertyNames.length - 1
                      ? _c("span", [_vm._v(", "), _c("br")])
                      : _vm._e()
                  ])
                }),
                0
              )
            : _c("div", [_vm._v("-")])
        ]
      ),
      _c(
        "b-form-group",
        {
          attrs: {
            label:
              "C) " + _vm.$t("incident_form_structure_organization_description")
          }
        },
        [
          _c("div", { staticClass: "text-break" }, [
            _vm._v(
              _vm._s(
                _vm._.get(_vm.entity, "structure_organization_description") ||
                  "-"
              )
            )
          ])
        ]
      ),
      _c(
        "b-form-group",
        { attrs: { label: "D) " + _vm.$t("incident_form_how_identified") } },
        [
          _c("div", { staticClass: "text-break" }, [
            _vm._v(_vm._s(_vm._.get(_vm.entity, "how_identified") || "-"))
          ])
        ]
      ),
      _c(
        "b-form-group",
        {
          attrs: {
            label:
              "E) " +
              _vm.$t("incident_form_holders_report") +
              " " +
              _vm.$t("incident_form_case_yes_contact")
          }
        },
        [
          _c("div", [
            _vm._v(
              _vm._s(_vm._.get(_vm.entity, "holders_report_incident") || "-")
            )
          ])
        ]
      ),
      _c(
        "b-form-group",
        {
          attrs: { label: "F) " + _vm.$t("incident_form_anpd_report_incident") }
        },
        [
          _c("div", { staticClass: "text-break" }, [
            _vm._v(_vm._s(_vm._.get(_vm.entity, "anpd_report_incident") || "-"))
          ])
        ]
      ),
      _c("h4", { staticClass: "mb-1 mt-1" }, [
        _vm._v(_vm._s(_vm.$t("incident_form.title_03")))
      ]),
      _c("hr"),
      _c(
        "b-form-group",
        { attrs: { label: "A) " + _vm.$t("incident_form_leaked_content") } },
        [
          _vm.getLeakedContentNames.length
            ? _c(
                "div",
                _vm._l(_vm.getLeakedContentNames, function(contentName, index) {
                  return _c("span", { key: index }, [
                    _vm._v(" " + _vm._s(contentName)),
                    index < _vm.getLeakedContentNames.length - 1
                      ? _c("span", [_vm._v(", "), _c("br")])
                      : _vm._e()
                  ])
                }),
                0
              )
            : _c("div", [_vm._v("-")])
        ]
      ),
      _c(
        "b-form-group",
        { attrs: { label: "B) " + _vm.$t("category_personal_data") } },
        [
          _c("div", { staticClass: "text-break" }, [
            _vm._v(
              _vm._s(_vm._.get(_vm.entity, "category_personal_data") || "-")
            )
          ])
        ]
      ),
      _c(
        "b-form-group",
        { attrs: { label: "C) " + _vm.$t("incident_form_data_old_or_new") } },
        [
          _c("div", { staticClass: "text-break" }, [
            _vm._v(_vm._s(_vm._.get(_vm.entity, "data_old_or_new") || "-"))
          ])
        ]
      ),
      _c(
        "b-form-group",
        { attrs: { label: "D) " + _vm.$t("number_affected_holders") } },
        [
          _c("div", [
            _vm._v(
              _vm._s(_vm._.get(_vm.entity, "number_affected_holders") || "-")
            )
          ])
        ]
      ),
      _c(
        "b-form-group",
        {
          attrs: {
            label:
              "E) " +
              _vm.$t("incident_form_total_affected_holders") +
              " (" +
              _vm.$t("incident_form_total_affected_holders_01") +
              ")"
          }
        },
        [
          _c("div", [
            _vm._v(
              _vm._s(_vm._.get(_vm.entity, "total_affected_holders") || "-")
            )
          ])
        ]
      ),
      _c("h4", { staticClass: "mb-1 mt-1" }, [
        _vm._v(_vm._s(_vm.$t("incident_form.title_04")))
      ]),
      _c("hr"),
      _c(
        "b-form-group",
        { attrs: { label: "A) " + _vm.$t("incident_form_date_incident") } },
        [
          _c("div", [
            _vm._v(_vm._s(_vm._.get(_vm.entity, "incident_date_fmt") || "-"))
          ])
        ]
      ),
      _c(
        "b-form-group",
        { attrs: { label: "B) " + _vm.$t("incident_form_date_authority") } },
        [
          _c("div", [
            _vm._v(_vm._s(_vm._.get(_vm.entity, "date_authority_fmt") || "-"))
          ])
        ]
      ),
      _c(
        "b-form-group",
        { attrs: { label: "C) " + _vm.$t("incident_form_reasons_delay") } },
        [
          _c("div", { staticClass: "text-break" }, [
            _vm._v(_vm._s(_vm._.get(_vm.entity, "reasons_delay") || "-"))
          ])
        ]
      ),
      _c("h4", { staticClass: "mb-1 mt-1" }, [
        _vm._v(_vm._s(_vm.$t("incident_form.title_05")))
      ]),
      _c("hr"),
      _c(
        "b-form-group",
        {
          attrs: {
            label:
              "A) " +
              _vm.$t("incident_form_data_protection_measures") +
              " (" +
              _vm.$t("incident_form_data_protection_measures_01") +
              ")"
          }
        },
        [
          _c("div", { staticClass: "text-break" }, [
            _vm._v(
              _vm._s(_vm._.get(_vm.entity, "data_protection_measures") || "-")
            )
          ])
        ]
      ),
      _c(
        "b-form-group",
        {
          attrs: {
            label: "B) " + _vm.$t("incident_form_actions_reverse_incident")
          }
        },
        [
          _c("div", { staticClass: "text-break" }, [
            _vm._v(
              _vm._s(_vm._.get(_vm.entity, "actions_reverse_incident") || "-")
            )
          ])
        ]
      ),
      _c(
        "b-form-group",
        {
          attrs: {
            label:
              "C) " +
              _vm.$t("incident_form_other_description") +
              " (" +
              _vm.$t("incident_form_other_description_01") +
              ")"
          }
        },
        [
          _c("div", { staticClass: "text-break" }, [
            _vm._v(_vm._s(_vm._.get(_vm.entity, "other_description") || "-"))
          ])
        ]
      ),
      _c("h4", { staticClass: "mb-1 mt-1" }, [
        _vm._v(_vm._s(_vm.$t("incident_form.title_06")))
      ]),
      _c("hr"),
      _c(
        "b-form-group",
        { attrs: { label: "A) " + _vm.$t("incident_form_related_risks") } },
        [
          _c("div", { staticClass: "text-break" }, [
            _vm._v(_vm._s(_vm._.get(_vm.entity, "related_risks") || "-"))
          ])
        ]
      ),
      _c(
        "b-form-group",
        {
          attrs: { label: "B) " + _vm.$t("incident_form_comunication_content") }
        },
        [
          _c("div", { staticClass: "text-break" }, [
            _vm._v(_vm._s(_vm._.get(_vm.entity, "comunication_content") || "-"))
          ])
        ]
      ),
      _vm.getCommunicationContentAttachments.length
        ? _c(
            "b-form-group",
            {
              attrs: {
                label:
                  "C) " +
                  _vm.$t("incident_form_communication_content_attachments")
              }
            },
            [
              _c(
                "b-list-group",
                _vm._l(_vm.getCommunicationContentAttachments, function(
                  file,
                  idx
                ) {
                  return _c(
                    "b-list-group-item",
                    {
                      key: idx,
                      staticClass:
                        "d-flex justify-content-between align-items-center"
                    },
                    [
                      _c("div", [
                        _c("i", {
                          staticClass:
                            "feather icon-file-text text-primary mr-2"
                        }),
                        _vm.getDownloadUrl(file)
                          ? _c(
                              "a",
                              {
                                staticClass: "mr-2 download-link text-primary",
                                attrs: {
                                  href: _vm.getDownloadUrl(file),
                                  target: "_blank",
                                  title: "Baixar arquivo"
                                }
                              },
                              [
                                _c("i", {
                                  staticClass: "feather icon-download"
                                })
                              ]
                            )
                          : _vm._e(),
                        _c("strong", [_vm._v(_vm._s(_vm.getFileName(file)))]),
                        _vm.getFileSize(file)
                          ? _c("small", { staticClass: "ml-2 text-muted" }, [
                              _vm._v(
                                " (" +
                                  _vm._s(
                                    _vm.formatFileSize(_vm.getFileSize(file))
                                  ) +
                                  ") "
                              )
                            ])
                          : _vm._e()
                      ])
                    ]
                  )
                }),
                1
              )
            ],
            1
          )
        : _vm._e(),
      _c(
        "b-form-group",
        { attrs: { label: "D) " + _vm.$t("incident_form_anpd_communicated") } },
        [
          _c("div", [
            _vm._.get(_vm.entity, "anpd_communicated") !== null &&
            _vm._.get(_vm.entity, "anpd_communicated") !== undefined
              ? _c("span", [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm._.get(_vm.entity, "anpd_communicated")
                          ? "Sim"
                          : "Não"
                      ) +
                      " "
                  )
                ])
              : _c("span", [_vm._v("-")])
          ])
        ]
      ),
      _c(
        "b-form-group",
        {
          attrs: {
            label: "E) " + _vm.$t("incident_form_reasons_lack_communication")
          }
        },
        [
          _c("div", { staticClass: "text-break" }, [
            _vm._v(
              _vm._s(_vm._.get(_vm.entity, "reasons_lack_communication") || "-")
            )
          ])
        ]
      ),
      _vm.getGeneralAttachments.length
        ? _c(
            "b-form-group",
            { attrs: { label: _vm.$t("incident_form_attachments") } },
            [
              _c(
                "b-list-group",
                _vm._l(_vm.getGeneralAttachments, function(file, idx) {
                  return _c(
                    "b-list-group-item",
                    {
                      key: idx,
                      staticClass:
                        "d-flex justify-content-between align-items-center"
                    },
                    [
                      _c("div", [
                        _c("i", {
                          staticClass:
                            "feather icon-file-text text-primary mr-2"
                        }),
                        _vm.getDownloadUrl(file)
                          ? _c(
                              "a",
                              {
                                staticClass: "mr-2 download-link text-primary",
                                attrs: {
                                  href: _vm.getDownloadUrl(file),
                                  target: "_blank",
                                  title: "Baixar arquivo"
                                }
                              },
                              [
                                _c("i", {
                                  staticClass: "feather icon-download"
                                })
                              ]
                            )
                          : _vm._e(),
                        _c("strong", [_vm._v(_vm._s(_vm.getFileName(file)))]),
                        _vm.getFileSize(file)
                          ? _c("small", { staticClass: "ml-2 text-muted" }, [
                              _vm._v(
                                " (" +
                                  _vm._s(
                                    _vm.formatFileSize(_vm.getFileSize(file))
                                  ) +
                                  ") "
                              )
                            ])
                          : _vm._e()
                      ])
                    ]
                  )
                }),
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }